import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames/bind'

import { FluidImage } from 'components/shared/fluid-image/FluidImage'
import styles from './portfolio-page.module.scss'

const cx = classNames.bind(styles)

class PortfolioPage extends Component {

    handleButtonClick = (route) => {
        this.props.history.push(route)
    }

    render() {
        return (
            <div className={cx("portfolio-page-wrapper")}>
                <div className={cx("container")}>
                    <div className={cx("portfolio-hero-wrapper")}>
                        <h1 className={cx(["animate__animated", "animate__fadeIn"])}>Portfolio of Justin Ashley</h1>
                        <div className={cx(["temp-main-portfolio", "animate__animated", "animate__fadeIn"])}>
                            <div className={cx(['d-none', 'd-md-inline-block'])}>
                                <FluidImage altText="onXmaps Project" image="/images/portfolio/featured-portfolio.jpg" />
                            </div>

                            <div className={cx(['d-md-none'])}>
                                <NavLink to="/portfolio/onxmaps">
                                    <FluidImage altText="onXmaps Project" image="/images/portfolio/onxmaps/home-main-banner-mobile.jpg" />
                                </NavLink>
                            </div>

                            <div className={cx('view-portfolio-button-wrapper')}>
                                <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/onxmaps")}>View onXmaps Project</button>
                            </div>
                        </div>
                    </div>

                    <div className={cx("row")}>
                        <div className={cx(["portfolio-thumbnails-wrapper", "col-md-4", "animate__animated", "animate__fadeInLeft"])}>
                            <NavLink to="/portfolio/hunting-gps-maps">
                                <FluidImage altText='HUNT by onXmaps' image='/images/portfolio/hunting-gps-maps/hunting-gps-maps-thumbnail.jpg' />
                            </NavLink>

                            <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/hunting-gps-maps")}>View HUNT Project</button>
                        </div>

                        <div className={cx(["portfolio-thumbnails-wrapper", "col-md-4", "animate__animated", "animate__fadeInUp"])}>
                            <NavLink to="/portfolio/roam-gps-maps">
                                <FluidImage altText='ROAM by onXmaps' image='/images/portfolio/roam-maps/roam-thumb.jpg' />
                            </NavLink>

                            <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/roam-gps-maps")}>View ROAM Project</button>
                        </div>

                        <div className={cx(["portfolio-thumbnails-wrapper", "col-md-4", "animate__animated", "animate__fadeInRight"])}>
                            <NavLink to="/portfolio/onxmaps-reporting-tool">
                                <FluidImage altText='onXmaps internal site' image='/images/portfolio/reporting-tool/onxmaps-reporting-tool-thumbnail.jpg' />
                            </NavLink>

                            <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/onxmaps-reporting-tool")}>View Report Tool Project</button>
                        </div>
                    </div>

                    <div className="row">
                        <div className={cx(["portfolio-thumbnails-wrapper", "col-md-4", "animate__animated", "animate__fadeInLeft"])}>
                            <NavLink to="/portfolio/acclaris">
                                <FluidImage altText='Acclaris 1.5' image='/images/portfolio/acclaris/acclaris-main-thumb-large.jpg' />
                            </NavLink>

                            <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/acclaris")}>View Acclaris Project</button>
                        </div>

                        <div className={cx(["portfolio-thumbnails-wrapper", "col-md-4", "animate__animated", "animate__fadeInUp"])}>
                            <NavLink to="/portfolio/where-to-buy">
                                <FluidImage altText='Where To Buy' image='/images/portfolio/where-to-buy/results-page-default-larger-thumb.jpg' />
                            </NavLink>

                            <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/where-to-buy")}>View Where To Buy Project</button>
                        </div>

                        {/*<div className={cx(["portfolio-thumbnails-wrapper", "col-md-4", "animate__animated", "animate__fadeInRight"])}>*/}
                        {/*    <NavLink to="/portfolio/masonite">*/}
                        {/*        <FluidImage altText='Masonite' image='/images/portfolio/masonite/home-page-thumb.png' />*/}
                        {/*    </NavLink>*/}

                        {/*    <button className={cx("primary-button")} onClick={() => this.handleButtonClick("/portfolio/masonite")}>View Masonite Project</button>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        )
    }
}

export default PortfolioPage;